export class UserDocuments {
    public  userId : string;
    public  documentType : string;    
    public  documentURL : string;
    public documentName : string;
    public  documentCategory : string;
    public createdAt? : Date;
    public adminView? : boolean;
}

export class UserDocumentsAddModel extends UserDocuments{    
       
}
